import logoFooter from '@/assets/logo-footer.png'
import { Mail } from 'lucide-react'
import SmoothScrollLink from './SmoothScrollLink'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="w-full bg-primary text-primary-foreground">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Logo & Tagline */}
          <div className="flex flex-col gap-4">
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <img
                src={logoFooter}
                alt="FotoLivro Store"
                className="h-12 w-auto opacity-90 hover:opacity-100 transition-opacity"
              />
            </a>
            <p className="text-lg md:text-xl text-accent font-serif font-bold italic">
              Suas memórias merecem ser tocadas.
            </p>
          </div>

          {/* Navegação */}
          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold font-sans uppercase tracking-wider text-primary-foreground">
              Navegação
            </h3>
            <nav className="flex flex-col gap-2">
              <SmoothScrollLink
                href="/parcerias#o-que-e"
                className="text-sm font-semibold text-primary-foreground/70 hover:text-primary-foreground transition-colors font-sans"
              >
                O que é?
              </SmoothScrollLink>
              <SmoothScrollLink
                href="/parcerias#beneficios"
                className="text-sm font-semibold text-primary-foreground/70 hover:text-primary-foreground transition-colors font-sans"
              >
                Benefícios
              </SmoothScrollLink>
              <SmoothScrollLink
                href="/parcerias#como-funciona"
                className="text-sm font-semibold text-primary-foreground/70 hover:text-primary-foreground transition-colors font-sans"
              >
                Como Funciona
              </SmoothScrollLink>
              <SmoothScrollLink
                href="/parcerias/sobre"
                className="text-sm font-semibold text-primary-foreground/70 hover:text-primary-foreground transition-colors font-sans"
              >
                Sobre a FotoLivro Store
              </SmoothScrollLink>
              <SmoothScrollLink
                href="/parcerias#faq"
                className="text-sm font-semibold text-primary-foreground/70 hover:text-primary-foreground transition-colors font-sans"
              >
                FAQ
              </SmoothScrollLink>
            </nav>
          </div>

          {/* Contato */}
          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold font-sans uppercase tracking-wider text-primary-foreground">
              Contato
            </h3>
            <a
              href="mailto:atendimento@fotolivro.store"
              className="flex items-center gap-2 text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors font-sans"
            >
              <Mail className="w-4 h-4" />
              atendimento@fotolivro.store
            </a>
          </div>

          {/* Redes Sociais */}
          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-semibold font-sans uppercase tracking-wider text-primary-foreground">
              Redes Sociais
            </h3>
            <div className="flex items-center gap-3">
              {/* Instagram */}
              <a
                href="https://www.instagram.com/fotolivrostore/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" className="w-7 h-7">
                  <defs>
                    <linearGradient
                      id="instagram-gradient"
                      x1="0%"
                      y1="100%"
                      x2="100%"
                      y2="0%"
                    >
                      <stop offset="0%" stopColor="#FFDC80" />
                      <stop offset="25%" stopColor="#FCAF45" />
                      <stop offset="50%" stopColor="#F77737" />
                      <stop offset="75%" stopColor="#F56040" />
                      <stop offset="90%" stopColor="#C13584" />
                      <stop offset="100%" stopColor="#833AB4" />
                    </linearGradient>
                  </defs>
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                    fill="url(#instagram-gradient)"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="4"
                    fill="none"
                    stroke="white"
                    strokeWidth="1.5"
                  />
                  <circle cx="17.5" cy="6.5" r="1.25" fill="white" />
                </svg>
              </a>

              {/* YouTube */}
              <a
                href="https://www.youtube.com/@fotolivrostore"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                aria-label="YouTube"
              >
                <svg viewBox="0 0 24 24" className="w-7 h-7">
                  <path
                    fill="#FF0000"
                    d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                  />
                </svg>
              </a>

              {/* WhatsApp */}
              <a
                href="https://wa.me/554137950568"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full flex items-center justify-center transition-transform hover:scale-110"
                aria-label="WhatsApp"
              >
                <svg viewBox="0 0 24 24" className="w-7 h-7">
                  <path
                    fill="#25D366"
                    d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-6">
          <div className="flex flex-col gap-4 text-center">
            <p className="text-xs text-primary-foreground/60 font-sans">
              © {currentYear} FotoLivro Store. Todos os direitos reservados.
            </p>
            <p className="text-xs text-primary-foreground/50 font-sans">
              PH Tecnologia LTDA | CNPJ: 40.524.684/0001-45 | Rua Imaculada
              Conceição, 1430, Prado Velho - Curitiba/PR
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
